/* eslint array-callback-return: 0 */ // --> OFF
/* eslint no-unused-expressions: 0 */ // --> OFF
/* eslint indent: 0 */ // --> OFF
/* eslint react/jsx-indent-props: 0 */ // --> OFF
import React from 'react';
import { arrayOf, shape, bool, string } from 'prop-types';
import classnames from 'classnames';
import { Row } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { MAP_POLICY_RANK } from '../../../constants';
import './promotions.scss';

export const Promotions = ({ mapPolicy, promotionalDiscounts, isMobile }) => {
  const getToolTipContent = (description) => {
    return (
      <p className={classnames({ 'package-pricing__promotions-tip-content-mobile': isMobile })}>
        {description}
      </p>
    );
  };

  if (!promotionalDiscounts.length) return null;

  return (
    <Row className="package-pricing__section package-pricing__promotions">
      <span className="package-pricing__promotions-header">Additional Savings</span>
      {promotionalDiscounts.map((promotion, index) => {
        const { shortDesc, longDesc } = promotion.description;

        return (
          <React.Fragment key={promotion.promoId}>
            <div className="package-pricing__promotions-short-wrapper">
              <span
                className="package-pricing__promotions-description"
                data-testid={`package-pricing__promotion-${index}`}
              >
                {shortDesc}
              </span>
              <Tooltip
                closeButton
                showClose={false}
                channel={isMobile ? 'mobile' : 'desktop'}
                content={getToolTipContent(longDesc)}
                mobileHeader="Promotion"
              >
                <div className="package-pricing__promotions-tip">View Details</div>
              </Tooltip>
            </div>
            <span
              className="package-pricing__promotions-discount"
              data-testid={`package-pricing__promotion-discount-${index}`}
            >
              -${promotion.totalDollarDiscount.toFixed(2)}
            </span>
          </React.Fragment>
        );
      })}
    </Row>
  );
};

Promotions.propTypes = {
  mapPolicy: string.isRequired,
  promotionalDiscounts: arrayOf(shape({})).isRequired,
  isMobile: bool.isRequired
};
